var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayout3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7658_18734)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 14.5,
    r: 12,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7658_18734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1768 9.20285C12.1768 8.40756 12.8308 7.76233 13.6368 7.76233H14.6102C15.4163 7.76233 16.0703 8.40756 16.0703 9.20285V19.7667C16.0703 20.562 15.4163 21.2072 14.6102 21.2072H13.6368C12.8308 21.2072 12.1768 20.562 12.1768 19.7667V9.20285Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5304 7.76233C17.7243 7.76233 17.0703 8.40756 17.0703 9.20285V19.7667C17.0703 20.562 17.7243 21.2072 18.5304 21.2072H19.5038C20.3099 21.2072 20.9638 20.562 20.9638 19.7667V9.20285C20.9638 8.40756 20.3099 7.76233 19.5038 7.76233H18.5304Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4239 7.76233C22.6179 7.76233 21.9639 8.40756 21.9639 9.20285V19.7667C21.9639 20.562 22.6179 21.2072 23.4239 21.2072H24.3973C25.2034 21.2072 25.8574 20.562 25.8574 19.7667V9.20285C25.8574 8.40756 25.2034 7.76233 24.3973 7.76233H23.4239Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7658_18734",
    x: 0.142857,
    y: 0.785714,
    width: 34.2857,
    height: 34.2857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.71429,
    dy: 3.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.57143
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7658_18734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7658_18734",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7658_18734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6806,
    height: 15.4449,
    fill: "white",
    transform: "translate(12.1768 6.76233)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout3);
export default __webpack_public_path__ + "static/media/layout_3.629c0b76fc4bb342c31a7a44ee61fa72.svg";
export { ForwardRef as ReactComponent };